import { call, put, takeLatest } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { GET } from '../consts/methods'
import {
  FETCH_MOBILE_REFERENCE_VALUES,
  FETCH_MOBILE_REFERENCE_VALUES_FAILURE,
  FETCH_MOBILE_REFERENCE_VALUES_SUCCESS,
  MobileReferencePayload
} from 'src/redux/mobileReferenceReducer'

interface Response {
  mobile_reference_values: MobileReferencePayload
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* FetchMobileReferenceValuesFlow(): Generator<any, void, any> {
  try {
    const response: Response = yield call(apiCall, {
      endpoint: '/dealers_api/mobile_reference_values',
      api: 'market-api',
      method: GET,
      params: {}
    })
    yield put(FETCH_MOBILE_REFERENCE_VALUES_SUCCESS(response.mobile_reference_values))
  } catch {
    yield put(FETCH_MOBILE_REFERENCE_VALUES_FAILURE())
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* FetchMobileReferenceValuesSaga(): Generator<any, void, any> {
  yield takeLatest(FETCH_MOBILE_REFERENCE_VALUES, FetchMobileReferenceValuesFlow)
}
